import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from "framer-motion"

export default function Buy() {
    const handleClick = () => {
        navigator.clipboard.writeText("0xB5FeB8Db42F29050e7CD1Afc5A309EbAd91714DA")
            .then(() => {
                alert('Copied to clipboard!');
            })
            .catch((error) => {
                console.error('Unable to copy: ', error);
            });
    };

    const redirectToBuy = () => {
        window.open('https://app.uniswap.org/swap?outputCurrency=0xB5FeB8Db42F29050e7CD1Afc5A309EbAd91714DA&chain=base')
      };

    return (
        <div className='mt-10 space-y-20 text-white font-Londrina flex flex-col items-center md:px-60'>
            <button className="border-2 border-white rounded-3xl p-2" onClick={handleClick}>
            0xB5FeB8Db42F29050e7CD1Afc5A309EbAd91714DA <FontAwesomeIcon icon={faCopy} />
            </button>

            <div className='md:px-60 md:py-10 flex flex-col bg-cyan-400 bg-opacity-75 text-center text-9xl border-2 rounded-3xl'>
                BUY IT ON
                <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className='mt-10 bg-white opacity-75 p-6 rounded-3xl' onClick={redirectToBuy}>
                    <img src={require("../assets/uniswap.png")} className="h-28" alt="Uniswap Logo" />
                </motion.button>
            </div>

            <div className='w-full mt-20 border-b-2 p-10'>

            </div>

        </div>
    );
}
